import cloneDeep from 'lodash/cloneDeep';
import { transformerFunctionsMap } from './helpers';

/**
 * This function converts the legacy VEP data structure to the new Splash CMS Engine data structure
 *
 * @param {object} legacyDataStructure - The legacy data structure
 * @param {string} state - The state that is being transformed
 *
 * @returns {object} - The new data structure OR an empty object if the legacy data structure is not valid
 *                   - this object MUST be in the { structure } format to match the saved data structure
 *
 * @throws {error} - If the legacy data structure transformation results in an error
 */

export default function convertLegacyToEngine(legacyDataStructure, state) {
    const transformStateDataFunction = transformerFunctionsMap[state];

    if (!transformStateDataFunction) {
        return {};
    }

    try {
        const legacyDataConfigs = cloneDeep(legacyDataStructure);
        const structure = Object.entries(legacyDataConfigs).reduce(transformStateDataFunction, {});

        return structure;
    } catch {
        return {};
    }
}
